<template>
  <div
    @click.stop="clicked(image.index)"
    style="position: relative"
    class="cursor-pointer tile column justify-center items-center content-center"
  >
    <div class="vt-icon" v-if="virtualtour">
      <q-img
        src="../../../../assets/icons/vt-360-white.svg"
        height="24px"
        width="24px"
      />
    </div>
    <div v-if="loading" class="spinner">
      <q-spinner-dots color="grey-5" size="1.5em"></q-spinner-dots>
    </div>
    <img @load="this.load" loading="lazy" ref="image" :src="imageUrl" />
    <div class="bottom">
      <div v-if="!loading && image.overline" class="overline">
        {{ image.overline }}
      </div>
      <div v-if="!loading" class="title">{{ image.title }}</div>
      <div v-if="!loading && image.caption" class="caption">
        {{ image.caption }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DFullScreenCarouselPickerTile",
  props: {
    image: {
      type: Object,
      required: true,
    },
    virtualtour: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      imageUrl: null,
    };
  },
  async mounted() {
    this.imageUrl = await this.image.src;
  },
  methods: {
    load() {
      this.loading = false;
    },
    clicked(index) {
      this.$emit("click", index);
    },
  },
};
</script>
<style lang="scss" scoped>
.tile {
  width: 100%;
  border-bottom: 1px solid #fff;
  margin: 1px 0;
  height: auto;
  min-height: 147px;
  position: relative;
}
.tile .spinner {
  position: absolute;
  z-index: 10;
}
.tile img {
  width: 100%;
  height: 100%;
  z-index: 11;
}
.tile .bottom {
  position: absolute;
  z-index: 12;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  width: 100%;
  padding: 4px 4px;
  font-size: 8px;
  font-weight: 600;
  line-height: 10px;
  text-transform: uppercase;
  letter-spacing: 0.22px;

  .overline {
    font-weight: 700;
  }
}

.vt-icon {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 999999;
}
</style>
